import { RView1jxdnn5qf89cm as RView } from './RView.commonHtml.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../models/data.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RViewWrapperClass;
function RViewWrapper() {
  if (RViewWrapperClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.ncu_1 = null;
      }
      zb8(_set____db54di) {
        this.ncu_1 = _set____db54di;
      }
      bb9() {
        var tmp0_elvis_lhs = this.ncu_1;
        var tmp;
        var tmp_0 = tmp0_elvis_lhs;
        if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
          var tmp1_safe_receiver = this.rb6_1;
          tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.bb9();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'RViewWrapper');
    RViewWrapperClass = $;
  }
  return RViewWrapperClass;
}
var RViewWithSecondaryActionClass;
function RViewWithSecondaryAction() {
  if (RViewWithSecondaryActionClass === VOID) {
    class $ extends RViewWithAction() {
      constructor(context) {
        super(context);
        this.ebd_1 = null;
        onRemove(this, () => {
          var tmp0_safe_receiver = this.ebd_1;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver();
          this.ebd_1 = null;
          return Unit_instance;
        });
        this.fbd_1 = null;
      }
    }
    initMetadataForClass($, 'RViewWithSecondaryAction');
    RViewWithSecondaryActionClass = $;
  }
  return RViewWithSecondaryActionClass;
}
var RViewWithActionClass;
function RViewWithAction() {
  if (RViewWithActionClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.jbg_1 = null;
        onRemove(this, () => {
          var tmp0_safe_receiver = this.jbg_1;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver();
          this.jbg_1 = null;
          return Unit_instance;
        });
        this.kbg_1 = null;
      }
      mbg(value) {
        this.kbg_1 = value;
        this.nbg(value);
      }
      nbg(value) {
        var tmp0_safe_receiver = this.jbg_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        var tmp = this;
        var tmp_0;
        if (value == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = this.wba(value);
        }
        tmp.jbg_1 = tmp_0;
      }
    }
    initMetadataForClass($, 'RViewWithAction');
    RViewWithActionClass = $;
  }
  return RViewWithActionClass;
}
//region block: exports
export {
  RViewWithAction as RViewWithActionov1gis5vq13n,
  RViewWithSecondaryAction as RViewWithSecondaryAction1hi9cbpgjqv82,
  RViewWrapper as RViewWrapper2fs4vvl2qig0l,
};
//endregion

//# sourceMappingURL=RView.mjs.map
